export default {
    show_unit_type_events_title: "Tipos de eventos de unidad",
    show_unit_type_events_name: "Nombre",
    show_unit_type_events_raw_event: "Evento sin procesar",
    show_unit_type_events_split_event_index: "Indice de evento dividido",
    show_unit_type_events_split_event_value: "Valor de evento dividido",
    show_unit_type_events_settings: "Configuración Dispositivo",
    show_unit_type_events_cloud_config: "Configuración de la nube",
    show_unit_type_events_compare_vesions: "Cambio entre versiones "
}